module.exports = __webpack_public_path__ + "lp/img/vote_bad.63580145.svg";